import { z } from "zod";

import { mediaSchema } from "./packaging-component/packaging-component-base";
import { packagingComponentStagedSchema } from "./packaging-solution-staged";
import { closingProductionOptionUsedSchema, productionOptionSchema } from "./production-option";

const closingProductionOptionSchema = productionOptionSchema.extend({
	cartonMaterialIds: z.array(z.string()).optional(),
	orientation: z.string().nullish(),
	machineType: z.string().nullish(),
	productionData: closingProductionOptionUsedSchema.shape.productionData,
});

export const cartonClosingStatusSchema = z.enum([
	"ClosingRequired",
	"Closing",
	"Closed",
	"ClosedManually",
	"ClosingFailed",
	"ClosingRemoved",
	"ClosingExpired",
]);

export const cartonClosingSchema = z.object({
	id: z.string(),
	status: cartonClosingStatusSchema,
	media: mediaSchema.extend({ cost: z.number().optional() }),
	usedProductionOption: closingProductionOptionUsedSchema.nullish(),
	productionOptions: z.array(closingProductionOptionSchema).optional(),
	labels: z
		.array(
			packagingComponentStagedSchema.extend({
				usedProductionOption: closingProductionOptionUsedSchema.nullish(),
			}),
		)
		.optional(),
	downstreamCompletedDateUTC: z.string().nullish(),
	startedClosingDateUTC: z.string().nullish(),
	lastFailedClosingDateUTC: z.string().nullish(),
	failureReason: z.string().nullish(),
	closingAttempt: z.number().int().nonnegative().optional(),
});

export type CartonClosing = z.infer<typeof cartonClosingSchema>;
